import { useMemo } from 'react';
import { ResearchSummary } from '../types/bom.types';
import { StageReport } from '../utils/stageActivity';
import { componentPhaseOf, isPhaseInProgress } from '../components/discovery/discoveryModel';
import { isResearchRunning, researchRobbieLine } from '../components/discovery/researchProgress';

/**
 * What Robbie's panel says about research while the buyer is on discovery:
 * the live "A of N done" line while it runs, nothing once it has landed.
 */
export const useDiscoveryResearchReport = (
  onDiscovery: boolean,
  summary: ResearchSummary | null,
  components: readonly unknown[],
): StageReport | null => {
  const line = summary && isResearchRunning(summary) ? researchRobbieLine(summary) : null;
  // Without the server summary, fall back to "nothing back yet" from the parts themselves.
  const allPending =
    components.length > 0 && components.every((c) => isPhaseInProgress(componentPhaseOf(c)));
  return useMemo(() => {
    if (!onDiscovery) return null;
    if (line) return { stage: 'research', text: line };
    if (!summary && allPending) return 'research';
    return null;
  }, [onDiscovery, line, summary, allPending]);
};

export default useDiscoveryResearchReport;
